import type { ApiAxis, ApiSku } from "@/lib/api";
import { isInquiryOnly, optionDisabled, type Selection } from "@/lib/cms-variants";
import { RadioGroup, RadioSwatch } from "@/components/ui/radio-group";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/** Round swatches for a colour axis. Unavailable combinations are struck through, not hidden. */
export function SwatchPicker({
  axis,
  skus,
  selection,
  onChange,
  labelledBy,
}: {
  axis: ApiAxis;
  skus: ApiSku[];
  selection: Selection;
  onChange: (valueId: string) => void;
  labelledBy: string;
}) {
  const values = axis.optionType.values.filter((v) => axis.valueIds.includes(v.id));
  return (
    <RadioGroup
      value={selection[axis.optionTypeId] ?? ""}
      onValueChange={onChange}
      aria-labelledby={labelledBy}
      className="flex flex-wrap gap-3"
    >
      {values.map((v) => {
        const disabled = optionDisabled(skus, selection, axis.optionTypeId, v.id, [axis]);
        const inquiry = isInquiryOnly([axis], axis.optionTypeId, v.id);
        return (
          <Tooltip key={v.id}>
            {/* A disabled button emits no pointer events, so the tooltip hangs
                off a wrapper — the one place a shopper most needs the name. */}
            <TooltipTrigger asChild>
              <span className="inline-flex rounded-full" tabIndex={disabled ? 0 : undefined}>
                <RadioSwatch value={v.id} label={v.label} image={v.swatchUrl} disabled={disabled} />
              </span>
            </TooltipTrigger>
            <TooltipContent>
              {inquiry ? `${v.label} · Konsultasi` : disabled ? `${v.label} · Habis` : v.label}
            </TooltipContent>
          </Tooltip>
        );
      })}
    </RadioGroup>
  );
}
